<ng-template #content_create_account let-offcanvas>
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.create_account">
    <div class="side_popup_header">
      <span>{{localService.languageContent.create_account.basic_info}}</span>
      <button class="button_icon" (click)="onCloseTrigger()">close</button>
    </div>
    <div class="side_popup_body" [ngStyle]="{'max-height' : (localService.sideBarBodyHeight + 50) + 'px'}">
      <div *ngIf="wrapper && wrapper.content && isOtpVerifiedForEdit == null">
        <div class="side_popup_body_row_group">
          <div class="side_popup_body_row" *ngIf="!wrapper.content.key || (wrapper.content.key && PhoneNumber)">
            <app-country-contact [countryCode]="ctryCode" [phoneNumber]="PhoneNumber"
              (onContactUpdated)="onContactUpdated($event)"
              (onEnterPressed)="localService.onFocusNextInput(elementIds.first_name,1)"
              [isSetFromLogin]="isSetFromLogin">
            </app-country-contact>
          </div>
          <div class="side_popup_body_row">
            <app-language-container style="top: 5px;    position: relative;" [MaxLength]="50" *ngIf="selectedContact"
              [id]="elementIds.name" [(languageContents)]="wrapper.languageNames"
              (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,1)" [isOnlyTransliterate]="true"
              [Title]="localService.languageContent.create_account.name" [isModeChangeAllowed]="false"
              [MandatoryLanguages]="mandatoryLanguages" [IsPartiallyMandatory]="true" [nextId]="elementIds.postal"
              [IsNeedNewLine]="true"></app-language-container>
          </div>
          <div class="side_popup_body_row">
            <app-language-container *ngIf="wrapper.content.key" style="top: 5px;  position: relative;" [MaxLength]="50"
              [id]="elementIds.name_short" [(languageContents)]="wrapper.languageNamesShort"
              [isOnlyTransliterate]="true" (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,2)"
              [Title]="localService.languageContent.create_account.name_short" [isModeChangeAllowed]="false"
              [MandatoryLanguages]="mandatoryLanguages" [nextId]="elementIds.postal"
              [IsNeedNewLine]="true"></app-language-container>
          </div>
          <div>
            <div class="row" *ngIf="isAddNewAddress">
              <div>
                <app-label [Text]="localService.languageContent.edit_additional_details.new_address"
                  [IsNeedNewLine]="true"></app-label>
              </div>
              <div>
                <input autocomplete="off" type="text" id="{{elementIds.txt_address_title}}" [(ngModel)]="addressTitle"
                  placeholder="{{localService.languageContent.edit_additional_details.address_title}}"
                  title="{{localService.languageContent.edit_additional_details.address_title}}" />
              </div>
              <div>
                <textarea rows="3" [(ngModel)]="address"
                  placeholder="{{localService.languageContent.edit_additional_details.new_address}}"
                  title="{{localService.languageContent.edit_additional_details.new_address}}"></textarea>
              </div>
            </div>
          </div>
          <div class="side_popup_body_row" *ngIf="!localService.isHideDummy">
            <app-label [Text]="localService.languageContent.local_locations.postal_code"
              [IsMandatory]="true"></app-label>
            <input id="{{elementIds.postal}}" *ngIf="!isAlphaNumericPostalCode" autocomplete="off" type="number"
              class="number" [ngClass]="wrapper.content.v8 ? 'en' : ''" [(ngModel)]="wrapper.content.v8"
              style="text-align:left;" (keypress)="localService.isNumberOnly($event,numericConfig)"
              placeholder="*{{localService.languageContent.local_locations.postal_code}}"
              title="*{{localService.languageContent.local_locations.postal_code}}"
              (keydown.enter)="localService.onFocusNextInput(elementIds.state,2)" />
            <input *ngIf="isAlphaNumericPostalCode" autocomplete="off"
              maxlength="{{numericConfig.maxDigits > 0 ? numericConfig.maxDigits : 50}}"
              [ngClass]="wrapper.content.v8 != '' ? 'en' : ''" type="text" id="{{elementIds.postal}}"
              [(ngModel)]="wrapper.content.v8"
              placeholder="*{{localService.languageContent.local_locations.postal_code}}"
              title="*{{localService.languageContent.local_locations.postal_code}}"
              (keydown.enter)="localService.onFocusNextInput(elementIds.state,2)" />
          </div>
          <div class="side_popup_body_row" *ngIf="!id">
            <div
              style="line-height: 20px; text-align: justify; margin-left: -15px; margin-top: 10px;margin-bottom:10px;">
              <label style="margin-left:30px;font-weight:normal;">
                <input type="checkbox" id="{{elementIds.agreement}}"
                  (change)="localService.onFocusNextInput(elementIds.save,5)" [(ngModel)]="isAgreementClicked">
                <span
                  style="font-size:16px;color:darkslategrey">{{localService.languageContent.create_account.create_account_agreement_1}}
                  <span class="button">{{localService.languageContent.create_account.create_account_agreement_2}}</span>
                  {{localService.languageContent.create_account.create_account_agreement_3}}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer modal_footer_message" *ngIf="message != ''">
        <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
      </div>
      <div class="modal-footer" *ngIf="isOtpVerifiedForEdit == null">
        <div class="row" style="width:100%;">
          <div class="col-8">
            <div *ngIf="refMember" class="reference_block">
              <div>
                <span style="color: darkgray;">{{localService.languageContent.create_account.refer_by}}</span>
              </div>
              <div>
                <span [ngClass]="localService.getLanguageCode(refMember.key)">{{refMember.value}}</span>
              </div>
            </div>
          </div>
          <div class="col-4" style="text-align:right;">
            <button type="button" class="btn btn-secondary" *ngIf="!localService.isHideDummy"
              (click)="onReset()">{{localService.languageContent.common.reset}}</button>
            <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onPopupSave()">{{id == '' ?
              localService.languageContent.common.create : localService.languageContent.common.update}}</button>
          </div>
        </div>
      </div>
      <app-otp-container *ngIf="isOtpVerifiedForEdit != null && isOtpVerifiedForEdit == false"
        [PhNumOrEmail]="PhoneNumber" [otpType]="7" (onVerified)="onOtpVerified($event)"></app-otp-container>
    </div>
  </div>
</ng-template>